import React, { useState } from "react";
import RegisterForm from "../components/RegisterForm";
import { Container, Typography, Link, Box } from "@mui/material";
import styled from "@emotion/styled";
import LoginForm from "../components/LoginForm";
import { motion } from "framer-motion/dist/framer-motion";

//////////////////////////////////
const RootStyle = styled("div")({
  background: "rgb(249, 250, 251)",
  height: "100vh",
  display: "grid",
  placeItems: "center",
});

const HeadingStyle = styled(Box)({
  textAlign: "center",
});

const ContentStyle = styled("div")({
  maxWidth: 480,
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  background: "#fff",
});

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 60,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

const Login = () => {
  const [isLoginForm, setIsLoginForm] = useState(true);

  return (
    <RootStyle>
      <Container maxWidth="sm">
        <ContentStyle>
          <HeadingStyle component={motion.div} {...fadeInUp}>
            {/* <Logo /> */}
            <Box textAlign="center" marginBottom="1rem">
              <img src="/logo.png" alt="Logo" widht="100" height="100" />{" "}
            </Box>
            {isLoginForm ? (
              <Typography variant="h5" sx={{ mb: 5 }}>
                Login to your account
              </Typography>
            ) : (
              <Typography variant="h5" sx={{ mb: 5 }}>
                Create a new account
              </Typography>
            )}
          </HeadingStyle>
          {isLoginForm ? <LoginForm /> : <RegisterForm />}

          {isLoginForm ? (
            <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center"
              sx={{ mt: 3 }}
            >
              Don’t have an account?{" "}
              <Link
                variant="subtitle2"
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={() => setIsLoginForm(false)}
              >
                Sign up
              </Link>
            </Typography>
          ) : (
            <Box textAlign="center" margin=".5rem 0">
              Already registered?{" "}
              <Link
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={() => setIsLoginForm(true)}
              >
                Sign in
              </Link>
            </Box>
          )}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};

export default Login;
